import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { RequestMethod, Response } from "@angular/http";
import { RequestConfig, RestResponse } from "../../../../shared/rest/rest.request";
import { CustomHttp } from "../../../../common/http/custom.http";
import { PageImpl } from "../../../../common/http/PageImpl";
import { NzI18nService, es_ES } from "ng-zorro-antd";

@Injectable()
export class TaskCategoryService {
    private CREATE_CODE = new RequestConfig("CTA", "application/json", true, RequestMethod.Post, "/task/categories");
    private EDIT_CODE = new RequestConfig("CTA", "application/json", true, RequestMethod.Put, "/task/categories/{idTaskCategory}");
    private DELETE_CODE = new RequestConfig("CTA", "application/json", true, RequestMethod.Delete, "/task/categories/{idTaskCategory}");
    private GET_CODE = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/task/categories/{idTaskCategory}");
    private GET_PAGE = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/task/categories");
    private GET_PARENTS = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/task/categories/parents");

    private GET_CLOSE_CATEGORY_TASK = new RequestConfig('TCA', 'application/json', true, RequestMethod.Get, '/taskCloseCategory/{idTaskCloseCategory}');
    private GET_CLOSE_SUBCATEGORY_TASK = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/taskCloseSubcategory/{idTaskCloseCategory}");

    private GET_ALL_TASK = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/task/categories/all");
    private GET_SUB__ALL_TASK = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/tasksubCategory/category/{idTaskCategory}");
    private EDIT_CODE_CATEGORY = new RequestConfig("TCA", "application/json", true, RequestMethod.Put, "/task/categories/{idTaskCategory}");

    private GET_ALL_TASK_CATEGORY_CLOSE = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/taskCloseCategory/all");

    private GET_ALL_TASK_FILTERED = new RequestConfig("CTA", "application/json", true, RequestMethod.Get, "/task/categories/all");

    private GET_MANO_OBRA = new RequestConfig("TCA", "application/json", true, RequestMethod.Get, "/taskLabor/labor");

    constructor(private http: CustomHttp,
        private i18n: NzI18nService) {
        this.i18n.setLocale(es_ES);
    }

    /**
     * Envia una petición a WS para guardar autorizacion
     */
    saveCategory(categoria: TaskCategoria): Observable<RestResponse> {
        return this.http.sendRequest(this.CREATE_CODE, categoria)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición a WS para obtener detalles de un autorizacion
     */
    getCategory(idTaskCategory: number): Observable<TaskCategoria> {
        return this.http.sendRequest(this.GET_CODE, {}, idTaskCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getAllTask(active?: boolean): Observable<CategoriaT> {
        let body = {};
        if (active === true || active === false) {
            body = { active: active };
        }
        return this.http.sendRequest(this.GET_ALL_TASK, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getAllTaskFiltered(active?: boolean, ticketType?: number, subCategoryId?: number): Observable<CategoriaT> {
        let body = {};
        if (active === true || active === false) {
            body = { active: active,id_type_ticket:ticketType,id_subcategory:subCategoryId }; 
        }
        return this.http.sendRequest(this.GET_ALL_TASK_FILTERED, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    getAllTaskCategoryClose(active?: boolean): Observable<any> { //TaskCloseCategoryView
        let body = {};
        if (active === true || active === false) {
            body = { active: active };
        }
        return this.http.sendRequest(this.GET_ALL_TASK_CATEGORY_CLOSE, body)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    getCategories(active: boolean): Observable<Array<CategoriaT>> {
        return this.http.sendRequest(this.GET_ALL_TASK, active)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }


    getSubcategories(idTaskCategory: number): Observable<subCategoriaT[]> {
        return this.http.sendRequest(this.GET_SUB__ALL_TASK, {}, idTaskCategory)
            .map((res) => res.json())
            .catch((error) => this.http.handleError(error));
    }


    getSubAllTask(idTaskCategory: number): Observable<CategoriaT> {
        return this.http.sendRequest(this.GET_SUB__ALL_TASK, {}, idTaskCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    getCategoriesClose(idTaskCloseCategory: number): Observable<Array<TaskCloseCategoryView>> {
        return this.http.sendRequest(this.GET_CLOSE_CATEGORY_TASK, {}, idTaskCloseCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getSubCategoriesClose(idTaskCloseCategory: number): Observable<Array<TaskCloseSubcategoryView>> {
        return this.http.sendRequest(this.GET_CLOSE_SUBCATEGORY_TASK, {}, idTaskCloseCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
    getManoObra(idTaskCloseCategory: number): Observable<Array<TaskCloseSubcategoryView>> {
        return this.http.sendRequest(this. GET_MANO_OBRA, {}, idTaskCloseCategory)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

   

    updateCategoryT(idTaskCategory: number): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE_CATEGORY, idTaskCategory)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }


    /**
     * Envía petición a WS para editar datos de autorizacion
     */
    updateCategory(categoria: TaskCategoria): Observable<RestResponse> {
        return this.http.sendRequest(this.EDIT_CODE, categoria, categoria.idTaskCategory)
            .map((res) => {
                try {
                    return res.json();
                } catch (e) {
                    return null;
                }
            })
            .catch(error => this.http.handleError(error));
    }

    /**
     * Envia petición al servidor para eliminar datos de autorizacion
     */
    deleteCategory(idTaskCategory: number) {
        return this.http.sendRequest(this.DELETE_CODE, {}, idTaskCategory)
            .catch(error => this.http.handleError(error));
    }


    getAll(active?: boolean): Observable<Array<TaskCategoria>> {
        return this.http.sendRequest(this.GET_PARENTS)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }

    findByParentCategory(parentId: number): any {
        return this.http.sendRequest(this.GET_PAGE, {
            parentId: parentId,
            page: 0,
            size: 100,
            active: true,
            general: false
        })
            .map((res): Response => res.json())
            .catch(error => this.http.handleError(error));
    }

    getPage(options: any): Observable<PageImpl<TaskCategoria>> {
        return this.http.sendRequest(this.GET_PAGE, options)
            .map(res => res.json())
            .catch(error => this.http.handleError(error));
    }
}

@Injectable()
export class TaskCategoria {
    public idTaskCategory: number;
    public categoryName: string;
    public active: boolean;
    public color: string;
    public idOrg: string;

    public parentId: number;
    public parentName: string;
    public parent: TaskCategoria;

}
export class SubCategoriaTicket {
    active: boolean;
    color: string;
    idCategory: number;
    idSubcategory: number;
    subcategoryName: string;
}

export class CategoriaT {
    active: boolean;
    categoryName: string;
    color: string;
    idOrg: number;
    idTaskCategory: number;
    idTypeTicket?:number;

}

export class closeCategoryTask {
    active: boolean;
    closeCategoryTaskName: string;
    color: string;
    idTaskCloseCategory: number;
}

export class subCategoriaT {
    active: boolean;
    code: number;
    color: string;
    idTaskCategory: number;
    idTaskSubcategory: number;
    subcategoryTaskName: string;
}

export class TaskSubCategory {
    active: boolean;
    code: string;
    color: string;
    idTaskCategory: number;
    idTaskSubcategory: number;
    subcategoryTaskName: string;
}

export class TaskCloseCategoryView {
    idTaskCloseCategory: number;
    closeCategoryTaskName: string;
    active: boolean;
    color: string;
    idTypeTicket?: number;
}

export class TaskCloseSubcategoryView {
    idTaskCloseSubcategory: number;
    closeSubcategoryTaskName: string;
    active: boolean;
    color: string;
    idTaskCloseCategory: number;
    idOrg: string;
    descripcion:string;
    maxMulti: any;
    minMulti: any;
}

export class CategoriaTaskAdvanceSearch {
    active: boolean;
    name: string;
    page: number;
    size: number;
    orderColumn: string;
    orderType: string;
}

export class AddMultiDefinitivo{
    id?: number;
    idCategory: number;
    categoryName: string;
    idCloseCategory: number;
    closeCategoryName: string;
    idSubCategoryClose?: number;
    subCategoryCloseName?: string;
    cantidad: number;
}